import { useSelector } from 'react-redux'

import { FormattedMessage } from 'react-intl'

import { selectUserProfile } from '@/features/domain/user'

import { useTexts } from './useTexts'

import { Alert, AlertTitle, Typography } from '@mui/material'

interface Props {
  trial: boolean
  allowSmsOverage: boolean
}

export function PlanDetailsWarningCard(props: Props) {
  const { trial, allowSmsOverage } = props

  const userProfile = useSelector(selectUserProfile)
  const texts = useTexts()

  if (trial) {
    return (
      <Alert severity="warning">
        <AlertTitle>{texts.trialTitle}</AlertTitle>
        <Typography variant="body2">
          <FormattedMessage
            id="option1"
            defaultMessage={texts.trialSubtitle}
            values={{
              b: chunks => (
                <Typography component="span" variant="body1" display="inline" fontWeight="bold">
                  {chunks}
                </Typography>
              ),
            }}
          />
        </Typography>
      </Alert>
    )
  }

  if (allowSmsOverage) {
    return (
      <Alert severity="warning">
        <AlertTitle>{texts.allowOverageTitle}</AlertTitle>
        <Typography variant="body2">
          <FormattedMessage
            id={texts.allowOverageSubtitle}
            values={{
              b: chunks => (
                <Typography fontWeight={600} display="inline">
                  {chunks}
                </Typography>
              ),
              accountEmail: userProfile.account.details.email,
            }}
          />
        </Typography>
      </Alert>
    )
  }

  return (
    <Alert severity="warning">
      <AlertTitle>{texts.dontAllowOverageTitle}</AlertTitle>
      <Typography variant="body2">
        <FormattedMessage
          id={texts.dontAllowOverageSubtitle}
          values={{
            b: chunks => (
              <Typography fontWeight={600} display="inline">
                {chunks}
              </Typography>
            ),
            accountEmail: userProfile.account.details.email,
          }}
        />
      </Typography>
    </Alert>
  )
}
